import { formOptions } from '@tanstack/react-form';

export type AdminUseFormData = {
  description?: string;
  name: string;
};

export const adminUseFormOptions = formOptions({
  defaultValues: {
    description: undefined,
    name: '',
  } as AdminUseFormData,
});
